import { makeStyles } from "@material-ui/core";
import * as React from "react";
import { checkDeviceType } from "src/helpers";

const useStyles = makeStyles((theme: any) => ({
  input: {
    "&:focus": {
      borderColor: "#aaaaaa"
    },
    "&[readonly]": {
      color: "rgba(0,0,0,.3)"
    },
    border: "1px solid #bdbdbd",
    borderRadius: 4,
    color: "#595959",
    fontSize: "1.6rem",
    height: "36px",
    lineHeight: "36px",
    padding: "0 15px",
    width: "100%"
  },
  mobileInput: {
    background: "none" as "none",
    border: "none" as "none",
    fontSize: "1.6rem",
    lineHeight: "1.6rem",
    width: "100%"
  },
  mobileLabel: {
    fontSize: "1rem"
  },
  mobileWrapper: {
    background: "#ffffff",
    border: "1px solid #bdbdbd",
    borderRadius: 4,
    color: "#545454",
    display: "block" as "block",
    padding: "6px 12px",
    [theme.breakpoints.up("md")]: {
      display: "none" as "none"
    }
  }
}));

interface IOwnProps {
  name?: string;
  placeholder?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value?: string;
  defaultValue?: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  dataTestId?: string;
}

const TextInput = ({ placeholder, ...otherProps }: IOwnProps) => {
  const mobileInputRef = React.useRef<HTMLInputElement>(null);
  const classes = useStyles();
  const handleMobileClick = React.useCallback(() => {
    if (mobileInputRef.current) {
      mobileInputRef.current.focus();
    }
  }, [mobileInputRef.current]);
  const deviceType = checkDeviceType();

  return (
    <>
      {deviceType === "mobile" ? (
        <div onClick={handleMobileClick} className={classes.mobileWrapper}>
          <div className={classes.mobileLabel}>
            <span>{placeholder}</span>
          </div>
          <input
            ref={mobileInputRef}
            type="text"
            placeholder={placeholder}
            className={classes.mobileInput}
            {...otherProps}
          />
        </div>
      ) : (
        <div>
          <input className={classes.input} placeholder={placeholder} type="text" {...otherProps} />
        </div>
      )}
    </>
  );
};

export default React.memo(TextInput);
